<template>
	<span>
		<!-- Error message -->
		<span v-show="show" class="text-danger">
			<i class="fa fa-warning"></i> 
			<slot></slot>
		</span>
	</span>
</template>

<script>
	export default {
		props: ['show'],
	}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// ErrorLabel.vue?3481f3d9